import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";
import { Button } from "scmp-app/components/common/button";

export const StyledBaseImage = styled(BaseImage)`
  margin-inline-start: 4px;
`;

export const ReadFullArticleButton = styled(Button)`
  flex-direction: row;

  inline-size: 100%;
  margin-inline-end: 12px;
  padding-block: 15px 14px;

  color: #4585ff;
  font-size: 18px;
  font-family: ${fontRoboto};

  border: 1px solid #4585ff;
  border-radius: 2px;

  background: #ffffff;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  color: #4585ff;

  ${ReadFullArticleButton} {
    background-color: transparent;
  }
`;
